import React from 'react';
import PropTypes from 'prop-types';

import PanasonicLogo from 'assets/images/panasonic-logo.png';

import {PlatformFooter} from 'pac-platform-ui-components';

import {IconSettings16, Tile} from 'pac-ux-components';

import {NavLink, Outlet} from 'react-router-dom';

import {Box, Center, SimpleGrid, Stack} from '@mantine/core';

const UserAgreementsLayout = () => (
    <Stack m="xl" p="xl" spacing="xl">
        <Center>
            <Tile elevation="medium">
                <Box padding="m">
                    <SimpleGrid>
                        <Center py="xl" className="border-bottom-primary">
                            <img
                                src={PanasonicLogo}
                                alt="Panasonic Avionics"
                                className="logo"
                            />
                        </Center>

                        <Box p="xl">
                            <NavLink to="/signin-options">
                                <IconSettings16 />
                            </NavLink>
                        </Box>

                        <Box p="xl">
                            <Outlet />
                        </Box>
                    </SimpleGrid>
                </Box>
            </Tile>
        </Center>

        <Box mt="xl" className="pac-footer">
            <PlatformFooter />
        </Box>
    </Stack>
);

UserAgreementsLayout.propTypes = {
    children: PropTypes.object,
};

export default UserAgreementsLayout;
